import _ from 'lodash';
import { zIndexManager } from 'components/sharpr/zIndex/manager/zIndexManager';

export function stickyDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: stickyDirectiveCtrl,
	};
}

export class stickyDirectiveCtrl {
	constructor($scope, $element, $attrs) {
		'ngInject';
		let options = _.extend(
			{
				offset: 0,
				className: 'pinned',
				onBeforeStick: () => {},
				onAfterStick: () => {},
				onBeforeUnstick: () => {},
				onAfterUnstick: () => {},
			},
			$scope.$eval($attrs.shSticky) || {}
		);
		let clone;
		let top = window.screen.height / 2;
		let isFixed = false;
		let isSetUp = false;
		let originalPosition;
		const scrollHandler = _.throttle(
			() => {
				if (!isSetUp) {
					isSetUp = true;
					top = $element[0].getBoundingClientRect().top;
					originalPosition = {
						position: $element.css('position'),
						top: $element.css('top'),
						left: $element.css('left'),
					};
				}
				if (!isFixed && (window.scrollY || window.pageYOffset) + options.offset >= top) {
					options.onBeforeStick({ element: $element[0], options, originalPosition });
					let rect = $element[0].getBoundingClientRect();
					if (!clone) {
						clone = document.createElement('div');
						// clone.style.backgroundColor = 'cyan';
					}
					clone.style.height = rect.height + 'px';
					// clone.style.zIndex = 1001;
					$element[0].parentNode.insertBefore(clone, $element[0]);
					$element
						.css({
							position: 'fixed',
							top: options.offset + 'px',
							left: '0',
						})
						.addClass(options.className);
					isFixed = true;
					zIndexManager.bringToTop($element);
					options.onAfterStick({
						element: $element[0],
						clone,
						options,
						originalPosition,
					});
				} else if (isFixed && (window.scrollY || window.pageYOffset) + options.offset < top) {
					options.onBeforeUnstick({
						element: $element[0],
						clone,
						options,
						originalPosition,
					});
					$element[0].parentNode.removeChild(clone);
					$element.css(originalPosition).removeClass(options.className);
					isFixed = false;
					options.onAfterUnstick({ element: $element[0], options, originalPosition });
				}
			},
			50,
			{ leading: true, trailing: true }
		);
		// run on scroll
		angular.element(window).on('scroll', scrollHandler);
		// run every 2 seconds to avoid problems with scrolling so fast
		// that we don't catch the fact that we are back at scrollY=0
		let intervalId = setInterval(scrollHandler, 2000);
		// when scope is destroyed, remove handlers
		$scope.$on('$destroy', () => {
			angular.element(window).off('scroll', scrollHandler);
			clearInterval(intervalId);
		});
	}
}
